import * as TinyCookie from "tiny-cookie";

var cookies = {
  // Gets a cookie.  If the cookie is not set or doesn't pass the given (optional) callback, return null.
  get: function(key, isValid) {
    var cookie = TinyCookie.getCookie(key);

    if (typeof cookie === "undefined" || cookie === null) return null;

    if (isValid) {
      if (typeof isValid !== "function") {
        console.error("'isValid' parameter must be a function.");
        return null;
      }

      if (!isValid(cookie.trim())) {
        console.warn("Cookie with key '" + key + "' is in an invalid format.");
        return null;
      }
    }

    return cookie;
  },

  // Gets a boolean cookie.  If the cookie is not set or not boolean, return null.
  getBool: function(key) {
    var cookie = TinyCookie.getCookie(key);
    if (typeof cookie === "undefined" || cookie === null) return null;
    if (cookie.trim() === "true") return true;
    if (cookie.trim() === "false") return false;
    else console.warn("Cookie with key '" + key + "' is not a boolean.");
    return null;
  },

  // Gets an integer cookie.  If the cookie is not set or can't be parsed into an integer, return null.
  getInt: function(key) {
    var cookie = TinyCookie.getCookie(key);
    if (typeof cookie === "undefined" || cookie === null) return null;

    var cookieInt = parseInt(cookie.trim());
    if (isNaN(cookieInt)) {
      console.warn("Cookie with key '" + key + "' is not an integer.");
      return null;
    }

    return cookieInt;
  },

  set: TinyCookie.setCookie, // takes key, value, options -- https://github.com/Alex1990/tiny-cookie
  remove: TinyCookie.remove, // takes key, options
};

export default cookies;
export { cookies };
